import { fontSizeS, spacingS } from "@rhumbix/rmbx_design_system_design_tokens";
import styled from "styled-components";
export const SigStage = styled.div `
    position: relative;
`;
export const SignatureInput = styled.div `
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 0;
    margin-top: -200px;

    label {
        margin: ${spacingS};
    }

    input:focus {
        outline: none;
    }
`;
export const FormInput = styled.input `
    box-sizing: border-box;
    margin: 0;
    font: inherit;
    font-family: inherit;
    display: block;
    width: 100%;
    height: 34px;
    padding: 6px 12px;
    font-size: ${fontSizeS};
    line-height: 1.42857143;
    color: @color-layout-secondary;
    background-color: @color-functional-white;
    background-image: none;
    border: 1px solid @color-functional-gray30;
    border-radius: 4px;
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
    transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
`;
